function stickyheaderLoadInit() {
    var windowScroll = window.scrollY;
    let scrollHeightValue = 0;
    var headerElement = document.querySelector('.main-header-top');
    let header = document.querySelector('header');
    if(header){
    
    let stickyHeader = header.getAttribute('data-sticky-header');
    let stickyHeaderType =  header.getAttribute('data-header-type');
    if (stickyHeader == 'true') {
      headerElement.classList.add('sticky-header-active');
    }
     if (stickyHeaderType == 'always'){
     document.querySelector('body').classList.add("sticky-header-always")  
     }
      
    if (headerElement.querySelector('[data-header-main]')) {
      var headerHeight = headerElement.querySelector('[data-header-main]').getBoundingClientRect().height.toFixed(2);;
      document.querySelector('body').style.setProperty('--headerheight', `${headerHeight}px`);
      scrollHeightValue = scrollHeightValue + headerHeight;
      var outerheight = headerHeight + 50;
    
      if(document.querySelector('.announcement-wrapper')){
          let announcementMain = document.querySelector('.announcement-wrapper');
        let annoucementHeight = announcementMain.getBoundingClientRect().height.toFixed(2);
        document.querySelector('body').style.setProperty('--announcementheight', `${annoucementHeight}px`);
      }
 
     if (window.innerWidth > 991) {
        if (headerElement.querySelector('[transparent="true"]')) {
          document.querySelector('body').style.setProperty('--transparentheaderheight', `${headerHeight}px`);
        } 
      }  
      window.addEventListener('scroll', function () {
        let mainHeader = document.querySelector('header');
        let stickyHeader = mainHeader.getAttribute('data-sticky-header');
       
        if (stickyHeader == 'false') {
          return false;
        }
    
        if (stickyHeader == 'true') {
          if (window.scrollY > 50) {
            headerElement.classList.add('stickytrue');
          } else {
            headerElement.classList.remove('stickytrue');
          }
           if (stickyHeaderType == 'on_scroll'){
               if (mainHeader && stickyHeader == 'true') {
                if (window.scrollY > 50) {
                  if (windowScroll > window.scrollY) {
                    headerElement.classList.remove('sticky-header-hidden');
                  } else {
                    if (!document.querySelector('body').classList.contains('menuopen')) {
                      headerElement.classList.add('sticky-header-hidden');
                    }
                  }
                } else {
                  headerElement.classList.remove('sticky-header-hidden');
                }
              } 
           }
        }
        windowScroll = window.scrollY;
      });
      window.addEventListener('resize', function () {
        setTimeout(function () {
          let headerHeight = headerElement.querySelector('[ data-header-main]').getBoundingClientRect().height.toFixed(2);;
          document.querySelector('body').style.setProperty('--headerheight', `${headerHeight}px`);

          if (window.innerWidth > 991) {
            if (headerElement.querySelector('.transparent-true')) {
              document.querySelector('body').style.setProperty('--transparentheaderheight', `${headerHeight}px`);
            }
          }
        }, 500);
      });
    }
    }
  }

function mobileHumburgerMenuInit() {
    let mobileHumburgerElements = document.querySelectorAll('[data-hamburger-mobile]');
    let headerMainParent = document.querySelector('header');
    let body = document.querySelector('body');

    Array.from(mobileHumburgerElements).forEach(function(element) {
        element.addEventListener("click", function(event) {
           event.preventDefault();  
          let drawerElement =  element.getAttribute("href");
          let contentDrawerContainer= document.querySelector(drawerElement);
             if(element.classList.contains('active')){
                if (body.classList.contains('mobile-menu-active')) {
                    body.classList.remove('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.remove('active');
                  element.classList.remove('active');
                }
             }else{
                    element.classList.add('active');
                    body.classList.add('no-scroll', 'mobile-menu-active');
                    contentDrawerContainer.classList.add('active');
              } 
        });
        
    })
    window.addEventListener("resize", function() {
        if (window.innerWidth > 991 && body.classList.contains('mobile-menu-active')) {
            body.classList.remove('mobile-menu-active', 'no-scroll');
            contentDrawerContainer.classList.remove('show');
        }
    })
}
function mobileMenuitemsEvent() {

  let mobileMenus = document.querySelectorAll(".mobile-menus-item");
    Array.from(mobileMenus).forEach(function(mobileMenu){
      mobileMenu.addEventListener("click",function(event){
        if(mobileMenu){
          mobileMenu.closest("[data-child-items]").classList.add("active")
        }
        
      })
    })
    let backToNavElemets = document.querySelectorAll("[data-backtonav-items],[data-subbacktonav-items]");
    Array.from(backToNavElemets).forEach(function(navBarbackElement) {
        navBarbackElement.addEventListener("click", function(event) {
          if(event.target.closest('details').hasAttribute("open")){
            event.target.closest('details[open]').removeAttribute("open");
            event.target.closest('[data-child-items].active').classList.remove("active");
          }      
        })
    })

}

function splitNavInit() {
  var navbar = document.querySelector('.navbar.logo-position-split');
  if (!navbar) return;
  if (window.innerWidth <= 991) return;

  var stage = navbar.querySelector('[data-split-stage]');
  var source = navbar.querySelector('[data-split-source] ul.navbar-nav');
  var logo = stage ? stage.querySelector('.logo-image') : null;
  if (!stage || !source || !logo) return;
  if (stage.classList.contains('split-ready')) return;

  var items = Array.from(source.children);
  if (!items.length) return;

  var leftCount = Math.floor(items.length / 2);

  var splitContainer = document.createElement('div');
  splitContainer.className = 'split-nav';

  var ulLeft = document.createElement('ul');
  ulLeft.className = 'no-bullet navbar-nav split-left';

  var ulRight = document.createElement('ul');
  ulRight.className = 'no-bullet navbar-nav split-right';

  items.forEach(function(li, idx) {
    if (idx < leftCount) ulLeft.appendChild(li);
    else ulRight.appendChild(li);
  });

  var logoHolder = document.createElement('div');
  logoHolder.className = 'split-logo';
  logoHolder.appendChild(logo);

  stage.innerHTML = '';
  splitContainer.appendChild(ulLeft);
  splitContainer.appendChild(logoHolder);
  splitContainer.appendChild(ulRight);
  stage.appendChild(splitContainer);
  stage.classList.add('split-ready');
}


document.addEventListener('DOMContentLoaded',  function (section = document) {
  stickyheaderLoadInit();
  mobileHumburgerMenuInit();
  mobileMenuitemsEvent();
  splitNavInit();
});

document.addEventListener('shopify:section:load',function (section) {
     let sectiontargetHead = section.target;
    stickyheaderLoadInit(sectiontargetHead);
    mobileHumburgerMenuInit(sectiontargetHead);
    mobileMenuitemsEvent(sectiontargetHead);
    splitNavInit();
});
